import en_us from './en_us';
import es from './es';

export default { en_us, es };
